import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=f066161e&scoped=true&"
import script from "./comment.js?vue&type=script&lang=js&"
export * from "./comment.js?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=f066161e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f066161e",
  null
  
)

export default component.exports